export default {
  defaultStyle: {
    display: 'inline'
  },
  portalDesign:{}
};
